import { DayOfWeek, DAYS_OF_WEEK, Duty, DutyConfiguration, SiteDutyConfig } from '../types';

/**
 * Converts SiteDutyConfig to DutyConfiguration for the modal
 */
export const convertToModalFormat = (config: SiteDutyConfig): DutyConfiguration => ({
  duty: config.duty,
  requirements: config.requirements
});


/**
 * Groups SiteDutyConfig records by day of week
 */
export const groupByDay = (
  configs: SiteDutyConfig[]
): Record<DayOfWeek, SiteDutyConfig[]> => {
  const grouped = {} as Record<DayOfWeek, SiteDutyConfig[]>;

  // Initialize all days with empty arrays
  DAYS_OF_WEEK.forEach(day => {
    grouped[day.value] = [];
  });

  // Group configurations by day
  configs.forEach(config => {
    const day = config.day.toLowerCase() as DayOfWeek;
    if (grouped[day]) {
      grouped[day].push(config);
    }
  });

  return grouped;
};

/**
 * Ensures all duty types are represented for each day, even if no requirements exist
 */
export const ensureAllDuties = (
  availableDuties: Duty[],
  existingConfigs: SiteDutyConfig[],
  dayOfWeek: DayOfWeek
): SiteDutyConfig[] => {
  const configsByDutyId = new Map(
    existingConfigs.map(config => [config.duty.id, config])
  );

  return availableDuties.map(duty => {
    const existing = configsByDutyId.get(duty.id);
    if (existing) {
      return existing;
    }

    // Create empty config for duties without requirements
    return {
      id: '',
      siteId: '',
      duty,
      day: dayOfWeek,
      requirements: null,
    };
  });
};

/**
 * Formats duty requirements for display
 */
export const formatDutyRequirements = (config: SiteDutyConfig): Array<{
  timeRange: string;
  minPersonnel: string;
}> => {
  if (!config.requirements || config.requirements.length === 0) {
    return [{
      timeRange: '--',
      minPersonnel: '--',
    }];
  }

  return config.requirements.map(requirement => ({
    timeRange: `${requirement.startTime} - ${requirement.endTime}`,
    minPersonnel: requirement.minPersonnel?.toString() || '--',
  }));
};
